/*
 * @Author: cxy
 * @Desc:
 * @Date: 2023-12-23 14:57:12
 * @LastEditTime: 2024-08-20 10:24:54
 */
import api from '@/api/'

export const strategyCommand = {
  edit(data) {
    this.isEdit = true
    this.visible = true
    this.$nextTick(() => {
      this.form = { ...data }
      const project = this.platformList.find(item => String(item.project) === String(this.form.project)
      )
      this.form.project = project.org
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      okText: '确定',
      cancelText: '取消',
      async onOk() {
        const res = await api.DeleteKeywords({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  },
  deletaAll(ids) {
    const _this = this
    if (ids.length <= 0) {
      _this.$message.warning('请选择数据')
      return
    }
      this.$confirm({
        content: `当前选择记录${ids.length}条，确定要删除吗？`,
        async onOk() {
          const res = await api.DeleteKeywords({ ids })
          if (_this.$validate(res)) {
            _this.$message.success('删除成功~')
            _this.pagination.current = 1
            _this.ids = []
            _this.getList()
          }
        }
      })
  }
}
